import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13dd6632&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd6632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/client_view_mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13dd6632')) {
      api.createRecord('13dd6632', component.options)
    } else {
      api.reload('13dd6632', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13dd6632&scoped=true&", function () {
      api.rerender('13dd6632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay-situation/index.vue"
export default component.exports